const DISMISS_KEY = "baysport_onboarding_dismissed";
const META_KEY = "baysport_onboarding_meta";
const COLLAPSED_KEY = "baysport_onboarding_collapsed";
const TOUR_SKIP_KEY = "baysport_onboarding_tour_skip";

export function isOnboardingDismissed(tenantId) {
  if (!tenantId) return false;
  return localStorage.getItem(`${DISMISS_KEY}_${tenantId}`) === "1";
}

export function dismissOnboarding(tenantId) {
  if (tenantId) localStorage.setItem(`${DISMISS_KEY}_${tenantId}`, "1");
}

export function resetOnboarding(tenantId) {
  if (!tenantId) return;
  localStorage.removeItem(`${DISMISS_KEY}_${tenantId}`);
  localStorage.removeItem(`${COLLAPSED_KEY}_${tenantId}`);
  localStorage.removeItem(`${META_KEY}_${tenantId}`);
  localStorage.removeItem(`${TOUR_SKIP_KEY}_${tenantId}`);
}

export function isOnboardingCollapsed(tenantId) {
  if (!tenantId) return false;
  return localStorage.getItem(`${COLLAPSED_KEY}_${tenantId}`) === "1";
}

export function setOnboardingCollapsed(tenantId, collapsed) {
  if (!tenantId) return;
  if (collapsed) {
    localStorage.setItem(`${COLLAPSED_KEY}_${tenantId}`, "1");
  } else {
    localStorage.removeItem(`${COLLAPSED_KEY}_${tenantId}`);
  }
}

export function getOnboardingMeta(tenantId) {
  if (!tenantId) return {};
  try {
    return JSON.parse(localStorage.getItem(`${META_KEY}_${tenantId}`) || "{}");
  } catch {
    return {};
  }
}

export function saveOnboardingMeta(tenantId, patch) {
  if (!tenantId) return;
  const prev = getOnboardingMeta(tenantId);
  localStorage.setItem(
    `${META_KEY}_${tenantId}`,
    JSON.stringify({ ...prev, ...patch }),
  );
}

export function isOnboardingTourSkipped(tenantId) {
  if (!tenantId) return true;
  return localStorage.getItem(`${TOUR_SKIP_KEY}_${tenantId}`) === "1";
}

export function skipOnboardingTour(tenantId) {
  if (tenantId) localStorage.setItem(`${TOUR_SKIP_KEY}_${tenantId}`, "1");
}
